import { Button, Center, Flex, Table, TableContainer, Tbody, Td, Tfoot, Text, Tr } from '@chakra-ui/react';
import { InfiniteData } from 'react-query';
import { AbsencePagination, AbsenceRecord } from '../../types';
import { useIntl } from 'react-intl';
import { AbsenceTableItem } from './AbsenceTableItem';
import { AttendanceTableSkeleton } from '../../screens/attendance/AttendanceTableSkeleton';

interface AbsenceTableProps {
    data?: InfiniteData<AbsencePagination>;
    fetchNextPage: () => void;
    hasNextPage: boolean | undefined;
    isFetchingNextPage: boolean;
    isLoading?: boolean;
    onItemClick: (item: AbsenceRecord) => void;
    onReviewSuccess?: () => void;
}

export const AbsenceTable: React.FC<AbsenceTableProps> = ({
    data,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
    isLoading,
    onItemClick,
    onReviewSuccess,
}) => {
    const items = data?.pages.flatMap((page) => page.data);
    const intl = useIntl();

    if (isLoading && !isFetchingNextPage) {
        return <AttendanceTableSkeleton />;
    }

    return (
        <TableContainer>
            <Table style={{ borderCollapse: 'separate', borderSpacing: '0 7px' }} variant={'unstyled'} size={'sm'} overflow={'hidden'}>
                <Tbody>
                    {!items ? (
                        <Tr>
                            <Td colSpan={4}>
                                <AttendanceTableSkeleton />
                            </Td>
                        </Tr>
                    ) : items.length === 0 ? (
                        <Tr>
                            <Td colSpan={4}>
                                <Center>
                                    <Text fontWeight={600}>{intl.formatMessage({ id: 'absence.noAbsences' })}</Text>
                                </Center>
                            </Td>
                        </Tr>
                    ) : (
                        items.map((item) => (
                            <AbsenceTableItem
                                key={item.id}
                                item={item}
                                onClick={() => onItemClick(item)}
                                onReviewSuccess={onReviewSuccess}
                            />
                        ))
                    )}
                </Tbody>
                <Tfoot>
                    <Tr>
                        <Td colSpan={4}>
                            {hasNextPage && (
                                <Flex p={2} width={'full'} alignItems={'center'} justifyContent={'center'}>
                                    <Button colorScheme="primary" onClick={fetchNextPage} isLoading={isFetchingNextPage}>
                                        {intl.formatMessage({ id: 'viewMore' })}
                                    </Button>
                                </Flex>
                            )}
                        </Td>
                    </Tr>
                </Tfoot>
            </Table>
        </TableContainer>
    );
};
